<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Crea oggetti digitali in 3D.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    La <span class="underline-p">progettazione digitale</span> e la
    <span class="underline-a">modellazione 3D</span> sono diventate negli ultimi
    anni competenze importanti e utili in diversi ambiti lavorativi, per questo
    è fondamentale insegnarle ai bambini fin dalla scuola.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/cube.png"
        alt="Cubo"
       
        class="cube"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Grazie al software online TinkerCAD, semplice e intuitivo, potranno
    divertirsi a
    <span class="underline-a">dare una forma concreta </span>
    <span class="underline-a">alle proprie idee.</span>
    La sezione Codeblocks all’interno del programma mette a disposizione degli
    studenti una libreria di blocchi di codice, per creare solidi e per
    effettuare operazioni logiche, matematiche e geometriche.
  </p>
</div>

<div class="fifth">
  <div class="row">
    <img
      src="../../../../assets/img/stampa-3d.png"
      alt="Stampa 3D"
     
      class="stampa-3d"
    />
  </div>
</div>

<div class="sixth container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Trasforma in oggetti reali le tue creazioni.
    </h3>
  </div>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    È poi possibile
    <span class="underline-p"
      >trasformare in prodotti reali gli oggetti creati sul computer,</span
    >trasformare in prodotti reali gli oggetti creati sul computer, grazie
    all’utilizzo di una stampante 3d. I ragazzi verranno introdotti alle diverse
    tecnologie di stampa, ai materiali da utilizzare e a come
    <span class="underline-a">ottimizzare il processo produttivo</span> per
    ottenere il risultato migliore.
  </p>
</div>

<div class="seventh container grid">
  <div class="row text-center">
    <div class="col-xl">
      <img
        src="../../../../assets/img/children-3d.png"
        alt="Children 3D Printing"
       
        class="c-3d"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
